module.exports = __webpack_public_path__ + "fonts/Barlow-Bold.f017c110.ttf";